var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExcel32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3 4.5v30.47L4 31.5V8l18.3-3.5Zm.86 3.52H35.2c.67 0 .8.13.8.8v21.84c0 .66-.13.8-.8.8H23.16v-2.07h4.6v-3.16h-4.6v-.95h4.6V22.1h-4.6v-.95h4.6V18h-4.6v-.95h4.6v-3.16h-4.6v-.95h4.6V9.76h-4.6V8.02ZM.01 38c0 1.1.9 2 2 2h35.98a2 2 0 0 0 2-2L40 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v36Z",
    fill: "#1E7145"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.98 14.08-1.65 3.78-1.28-3.55-2.06.1 2.04 5.16-2.3 5.05 2.03.16 1.62-3.64 1.52 3.85 2.33.12-2.53-5.56 2.42-5.62-2.14.15Z",
    fill: "#1E7145"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7 29.39h5.23v-3.16H28.7v3.16Z",
    fill: "#1E7145"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7 25.28h5.23V22.1H28.7v3.17Z",
    fill: "#1E7145"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7 21.16h5.23V18H28.7v3.17Z",
    fill: "#1E7145"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7 12.93h5.23V9.76H28.7v3.17Z",
    fill: "#1E7145"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7 17.04h5.23v-3.16H28.7v3.16Z",
    fill: "#1E7145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel32);
export default ForwardRef;